import call from './call';
import {push} from "connected-react-router";
import {CODES_ROUTE, LOGIN_ROUTE} from "../components/Root/routes";
import {UPDATE_DATA} from "../types";
import messageShow from "./messageShow";

const requestCertificate= (formValues) => async (dispatch) =>
{
    if(formValues.userExists)
    {
        dispatch(push(LOGIN_ROUTE));
        return;
    }
    const onResult= (result) =>
    {
        if(result && result[1])
        {
            if(result[1].success)
            {
                dispatch({type:UPDATE_DATA,payload:result[1]});
                dispatch(push(CODES_ROUTE));
            }
            else
                dispatch(messageShow({message: result[1].error, type: 'error'}));
        }
    }
    dispatch(call("Service/requestCertificate",formValues,onResult));
};
export default requestCertificate;